import React, { useContext, useEffect, useState } from "react";
import { DefaultPageContainer } from "../../components/layoutContainer/styles/LayoutContainer";
import { GlobalSubheader } from "../../components/subHeader/GlobalSubheader";
import { GlobalContext } from "../../contexts/GlobalContext";
import { ofxAuth } from "../../repositories/OfxConversor";
import { notify } from "../../utils/notify";
import { getAccountantClients } from "../../repositories/portal_api/AccountantClient";
import { CircularProgress } from "@material-ui/core";

export const OfxConversor = () => {
  const { companyUser, userLogged, setBreadcrumbs, setSidebarAction } =
    useContext(GlobalContext);
  const [loading, setLoading] = useState(false);
  const [clientList, setClientList] = useState([]);
  const [renderOfx, setRenderOfx] = useState(false);

  async function authOfx() {
    const response = await ofxAuth(userLogged?.userId);
    return response;
  }

  useEffect(() => {
    setSidebarAction((previous) => ({
      ...previous,
      open: false,
    }));

    getAccountantClientsList();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (renderOfx) {
      setBreadcrumbs([]);
      authOfx().then((response) => {
        if (response?.success) {
          renderComponent(response?.data?.access_token);
        } else {
          notify("Ocorreu um erro na autenticação do OFX!");
        }
      });
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [renderOfx]);

  const getAccountantClientsList = async () => {
    setLoading(true);
    let accountantClientsResponse = await getAccountantClients();
    if (accountantClientsResponse?.data?.length === 0) {
      setClientList([]);
      setLoading(false);
    } else {
      const mappedClients = accountantClientsResponse.data.map((client) => ({
        name: client.company_name,
        document: client.document,
      }));
      setClientList(mappedClients);
    }
    setRenderOfx(true);

    setTimeout(() => {
      setLoading(false);
    }, 1400);
  };

  const renderComponent = (authToken) => {
    let referenceId = "";
    let targetId = null;

    if (companyUser.isAccountant) {
      referenceId = companyUser?.document;
    } else {
      referenceId = companyUser?.accountantCnpj || companyUser.document;
      targetId = companyUser?.document;
    }
    if (companyUser) {
      const instance = window.QyonPdf2Ofx({
        access_token: authToken,
        user_id: userLogged?.userId,
        reference_id: referenceId,
        target_list: clientList,
        target_id: targetId,
        primary_color: "#0036b3",
      });

      instance.render();
    }
  };

  return (
    <>
      <GlobalSubheader title={"Extrato Fácil"} />
      <DefaultPageContainer
        style={{
          height: "calc(100% - 60px)",
          display: "flex",
          flexDirection: "column",
        }}
      >
        <div
          style={{
            background: "#fff",
            border: "1px solid #E0E0E0",
            borderRadius: 15,
            paddingLeft: 25,
            paddingRight: 25,
            paddingTop: 15,
            paddingBottom: 15,
          }}
        >
          {loading && (
            <div
              style={{
                display: "flex",
                width: "100%",
                justifyContent: "center",
              }}
            >
              <CircularProgress />
            </div>
          )}

          <div id="qyon-pdf2ofx"></div>
        </div>
      </DefaultPageContainer>
    </>
  );
};
